import { useCallback, useEffect } from 'react';

import { useMatch, useNavigate } from 'react-router-dom';
import { Tabs } from 'ui';
import { useScrollIntoView } from 'ui/Hooks';

import { useCausePageContext } from '../../CauseContext';
import classes from './CausePageTabs.module.css';

const CausePageTabs = () => {
  const { showStoreTab, showFundraisersTab, showTicketsTab } = useCausePageContext();
  const navigate = useNavigate();
  const subpath = useMatch('/causes/:uuid/:subpath/*');

  const { scrollIntoView, targetRef, scrollableRef } = useScrollIntoView<
    HTMLButtonElement,
    HTMLDivElement
  >({
    axis: 'x',
    isList: true,
  });

  const shouldHideTabs = !showStoreTab && !showFundraisersTab && !showTicketsTab;

  const handleTabChange = useCallback(
    (val: string | null) => {
      if (val) {
        navigate(val);
      }
    },
    [navigate]
  );

  const currentTab = subpath?.params.subpath ?? 'about';

  useEffect(() => {
    if (targetRef.current) {
      scrollIntoView({ alignment: 'center' });
    }
  }, [currentTab, scrollIntoView, targetRef]);

  if (shouldHideTabs) {
    return null;
  }

  return (
    <Tabs
      value={currentTab}
      onChange={handleTabChange}
      classNames={{
        root: classes.CausePageTabs,
        list: classes.CausePageTabs__list,
        tab: classes.CausePageTabs__tab,
      }}
    >
      <Tabs.List grow ref={scrollableRef}>
        <Tabs.Tab ref={currentTab === 'about' ? targetRef : undefined} value="about">
          About
        </Tabs.Tab>
        {showStoreTab ? (
          <Tabs.Tab ref={currentTab === 'shop' ? targetRef : undefined} value="shop">
            Store
          </Tabs.Tab>
        ) : null}
        {showFundraisersTab ? (
          <Tabs.Tab ref={currentTab === 'campaigns' ? targetRef : undefined} value="campaigns">
            Fundraisers
          </Tabs.Tab>
        ) : null}
        {showTicketsTab ? (
          <Tabs.Tab ref={currentTab === 'events' ? targetRef : undefined} value="events">
            Tickets
          </Tabs.Tab>
        ) : null}
      </Tabs.List>
    </Tabs>
  );
};

export { CausePageTabs };
